module.exports = __webpack_public_path__ + "static/retirement2-1a63a1f264591bddaedc042a4805bc6e.png";